import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-responsive-container',
  templateUrl: './responsive-container.component.html',
  styleUrls: ['./responsive-container.component.scss'],
})
export class ResponsiveContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
